import Meta from "./Meta";

export default class Addon {
  meta: Meta;
  productName: string;
  displayName: string;
  ingredientsDescription: string;
  shortDescription: string;
  type1: string;
  type2: string;
  image: string;
  readMore: string;
  imageMobile: string;

  constructor(addon: any) {
    this.meta = addon.meta;
    this.productName = addon.productname;
    this.displayName = addon.displayname;
    this.ingredientsDescription = addon.ingredientsdescription;
    this.shortDescription = addon.shortdescription;
    this.type1 = addon.type1;
    this.type2 = addon.type2;
    this.image = addon.image;
    this.readMore = addon.readmore;
    this.imageMobile = addon.image_mobile;
  }
}
